import { hunspellChecker } from '@addictivegroup/addictive-richtext/hunspell'
import plAff from '../../node_modules/dictionary-pl/index.aff?url'
import plDic from '../../node_modules/dictionary-pl/index.dic?url'
import enAff from '../../node_modules/dictionary-en/index.aff?url'
import enDic from '../../node_modules/dictionary-en/index.dic?url'
import { useSession } from '@/stores/session.js'

/**
 * The spelling of what is typed (D-208): addictive-richtext's Hunspell checker with Polish
 * (sjp.pl's, MPL 2.0) and English (SCOWL's, MIT/BSD) dictionaries served from this origin; one's
 * own words kept in one's settings, on every device.
 */
export const spelling = hunspellChecker({
  dictionaries: { pl: [plAff, plDic], en: [enAff, enDic] },
  save: (words) => useSession().updateSettings({ spelling_words: words }).catch(() => null),
})
